
export default {
  name: 'Video',
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
  methods: {
    sendVideoEvent() {
      ga('send', {
        hitType: 'event',
        eventCategory: 'Video',
        eventAction: 'play',
        eventLabel: this.slice.primary.raw_url.url,
      })
    },
  },
}
